<template>
  <b-row>
    <b-col
      cols="12"
    >
      <b-list-group>
        <b-list-group-item>
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-weight-bolder font-medium-2">
              Puan Ortalaması
            </div>
            <div>
              <b-form-rating
                no-border
                class="bg-transparent"
                variant="warning"
                :value="dataItem.rating_avg"
                size="lg"
                readonly
              />
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-weight-bolder">
              Lezzet
            </div>
            <div>
              <b-form-rating
                no-border
                class="bg-transparent"
                variant="warning"
                :value="dataItem.flavor_rating"
                size="sm"
                readonly
              />
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-weight-bolder">
              Hizmet
            </div>
            <div>
              <b-form-rating
                no-border
                class="bg-transparent"
                variant="warning"
                :value="dataItem.service_rating"
                size="sm"
                readonly
              />
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-weight-bolder">
              Menü İçeriği
            </div>
            <div>
              <b-form-rating
                no-border
                class="bg-transparent"
                variant="warning"
                :value="dataItem.menu_content_rating"
                size="sm"
                readonly
              />
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-weight-bolder">
              Ortam
            </div>
            <div>
              <b-form-rating
                no-border
                class="bg-transparent"
                variant="warning"
                :value="dataItem.environment_rating"
                size="sm"
                readonly
              />
            </div>
          </div>
        </b-list-group-item>
        <b-list-group-item>
          <div class="d-flex align-items-center justify-content-between">
            <div class="font-weight-bolder">
              Fiyatlandırma
            </div>
            <div>
              <b-form-rating
                no-border
                class="bg-transparent"
                variant="warning"
                :value="dataItem.price_rating"
                size="sm"
                readonly
              />
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BListGroup, BListGroupItem, BFormRating,
} from 'bootstrap-vue'

export default {
  name: 'RatingCard',
  components: {
    BFormRating,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
  },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
}
</script>
